import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "bootstrap-daterangepicker/daterangepicker.css";
import Chart from "react-apexcharts";
import ReactApexChart from "react-apexcharts";
import { Doughnut } from "react-chartjs-2";
import ApexCharts from "react-apexcharts";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { all_routes } from "../../Router/all_routes";
import PredefinedDateRanges from "../../core/common/range-picker/datePicker";
import {
  getTotalProducts,
  getTotalStock,
  getTotalOutOfStock,
  getSalesInvoiceTotals,
  getTotalSuppliers,
  getTotalCustomers,
  getTotalOrders,
  getCustomersOverview,
  getTopSellingProducts,
  getLowStock,
  getRecentSales,
  getSalesStats,
  getRecentTransactions,
  getTopCustomers,
  getTopCategories,
  getOrderStatistics,
} from "../../api/dashboard.js";

import { isDemoActive, getDemoReason } from "../../api/client";
import { mockDashboard } from "../../api/mock/dashboard";

// Register the necessary components for Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);
const NewDashboard = ({ storeId, warehouseId }) => {
  const route = all_routes;
  const BASE_IMG = (process.env.REACT_APP_API_IMAGE_BASE_URL || "https://hamilton-shop-images.s3.ap-south-1.amazonaws.com").replace(/\/$/, "");

  function resolveImageUrl(path, fallback) {
  // no path? use fallback if provided
  if (!path) return fallback || "";

  // already absolute (http/https//protocol-relative) or data URL → leave as is
  if (/^(?:https?:)?\/\//i.test(path) || /^data:/i.test(path)) return path;

  // clean leading slashes from the relative path
  const cleaned = String(path).replace(/^\/+/, "");

  // if no base provided, fall back to the relative path (or fallback)
  if (!BASE_IMG) return cleaned || fallback || "";

  return `${BASE_IMG}/${cleaned}`;
}

  // Static data for demo mode
  const [demo, setDemo] = useState(isDemoActive());

  // ---- total products state ----
  const [totalProducts, setTotalProducts] = useState(0);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [prodErr, setProdErr] = useState("");

  // ---- total stock state ----
  const [totalStock, setTotalStock] = useState(0);
  const [loadingStock, setLoadingStock] = useState(true);
  const [stockErr, setStockErr] = useState("");

  // ---- total out of stock state ----
  const [totalOOS, setTotalOOS] = useState(0);
  const [loadingOOS, setLoadingOOS] = useState(true);
  const [oosErr, setOosErr] = useState("");

  // ---- total sales invoice state ----
  const [invTotals, setInvTotals] = useState({
    count: 0,
    totalAmount: 0,
    totalPaid: 0,
    totalDue: 0,
  });
  const [loadingInv, setLoadingInv] = useState(true);
  const [invErr, setInvErr] = useState("");
  const [invoiceTotalsErr, setInvoiceTotalsErr] = useState("");

  //   total suppliers state ----
  const [supplierCount, setSupplierCount] = useState(0);
  const [loadingSuppliers, setLoadingSuppliers] = useState(true);
  const [supErr, setSupErr] = useState("");

  //   total customers state ----

  const [customerCount, setCustomerCount] = useState(0);
  const [loadingCustomers, setLoadingCustomers] = useState(true);
  const [custErr, setCustErr] = useState("");

  //   total order state
  const [orderCount, setOrderCount] = useState(0);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const [orderErr, setOrderErr] = useState("");

  //   total customer overview
  const [custPeriod, setCustPeriod] = useState("today"); // "today" | "weekly" | "monthly"
  const [loadingCO, setLoadingCO] = useState(true);
  const [coErr, setCoErr] = useState("");
  const [firstTime, setFirstTime] = useState(0);
  const [returning, setReturning] = useState(0);
  const [firstTimePct, setFirstTimePct] = useState(0);
  const [returningPct, setReturningPct] = useState(0);
  const [series, setSeries] = useState([0]); // radialBar expects an array

  //   top selling products
  const [topPeriod, setTopPeriod] = useState("today"); // "today" | "weekly" | "monthly"
  const [topItems, setTopItems] = useState([]);
  const [loadingTop, setLoadingTop] = useState(true);
  const [topErr, setTopErr] = useState("");

  //   top low stock product
  const [lowItems, setLowItems] = useState([]);
  const [lowLoading, setLowLoading] = useState(true);
  const [lowErr, setLowErr] = useState("");

  //   Recent Sales
  const [rsPeriod, setRsPeriod] = useState("weekly"); // "today" | "weekly" | "monthly"
  const [rsItems, setRsItems] = useState([]);
  const [rsLoading, setRsLoading] = useState(true);
  const [rsErr, setRsErr] = useState("");

  //   Sales static
  const thisYear = new Date().getFullYear();
  const [selYear, setSelYear] = useState(thisYear);
  const [stats, setStats] = useState({
    categories: Array(12).fill(""),
    series: { revenue: Array(12).fill(0) },
    totals: { revenue: 0, orders: 0, expense: null },
    yoy: { revenuePct: 0 },
  });
  const [loadingStats, setLoadingStats] = useState(true);
  const [statsErr, setStatsErr] = useState("");

  const yearsList = useMemo(() => [thisYear, thisYear - 1, thisYear - 2], []);

  //   Recent TRANSACTION
  const [saleRows, setSaleRows] = useState([]);
  const [saleLoading, setSaleLoading] = useState(true);
  const [saleErr, setSaleErr] = useState("");

  const [invRows, setInvRows] = useState([]);
  const [invLoading, setInvLoading] = useState(true);

  //   Get to Customer
  // ---- Top Customers (state) ----
  const [tcItems, setTcItems] = useState([]);
  const [tcLoading, setTcLoading] = useState(true);
  const [tcErr, setTcErr] = useState("");
  const [topCustPeriod, setTopCustPeriod] = useState("weekly");

  //   get top category
  const [topCat, setTopCat] = useState({
    items: [],
    totalCategories: 0,
    totalProducts: 0,
    chart: { labels: [], series: [] },
  });
  const [loadingTopCat, setLoadingTopCat] = useState(true);
  const [topCatErr, setTopCatErr] = useState("");
  const [catPeriod, setCatPeriod] = useState("weekly");

  //   get order statistics
  const [period, setPeriod] = useState("weekly"); // "today" | "weekly" | "monthly"
  const [heatSeries, setHeatSeries] = useState([]); // from API
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const label = useMemo(
    () =>
      period === window.translate("today")
        ? window.translate("Today")
        : period === window.translate("monthly")
        ? window.translate("Monthly")
        : window.translate("Weekly"),
    [period]
  );

  useEffect(() => {
    const ctrl = new AbortController();
    setLoadingStats(true);
    setStatsErr("");
    getSalesStats({
      year: selYear,
      source: ["invoice", "online"],
      signal: ctrl.signal,
    })
      .then((data) => setStats(data))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setStats(mockDashboard.stats);
          return;
        }
        setStatsErr(e.message || "Failed to load");
      })
      .finally(() => setLoadingStats(false));
    return () => ctrl.abort();
  }, [selYear]);

  function formatCurrency(amount, currency = "KWD", locale = "en-KW") {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(Number(amount || 0));
  }

  // Resolve storeId from props or localStorage (fallback)
  const resolvedStoreId = useMemo(() => {
    if (storeId) return storeId;
    if (typeof window !== "undefined") {
      return (
        localStorage.getItem("storeId") ||
        localStorage.getItem("store_id") ||
        ""
      );
    }
    return "";
  }, [storeId]);

  // call this instead of setTopPeriod directly
  const selectTopPeriod = (p) => {
    if (p !== topPeriod) {
      // show loader instantly, even before useEffect runs
      setLoadingTop(true);
      setTopPeriod(p);
    }
  };

  //   Get Total Products
  useEffect(() => {
    const ctrl = new AbortController();
    setLoadingProducts(true);
    setProdErr("");

    getTotalProducts({
      storeId: resolvedStoreId || undefined,
      warehouseId,
      signal: ctrl.signal,
    })
      .then(({ totalProducts }) => setTotalProducts(totalProducts ?? 0))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setTotalProducts(mockDashboard.totals.totalProducts);
          return;
        }
        setProdErr(e.message || "Failed to load");
      })
      .finally(() => setLoadingProducts(false));
    return () => ctrl.abort();
  }, [resolvedStoreId, warehouseId]);

  // Load total stock
  useEffect(() => {
    const ctrl = new AbortController();
    setLoadingStock(true);
    setStockErr("");

    getTotalStock({
      storeId: resolvedStoreId || undefined,
      warehouseId,
      signal: ctrl.signal,
    })
      .then(({ totalStock }) => setTotalStock(totalStock ?? 0))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setTotalStock(mockDashboard.totals.totalStock);
          return;
        }
        setStockErr(e.message || "Failed to load");
      })
      .finally(() => setLoadingStock(false));

    return () => ctrl.abort();
  }, [resolvedStoreId, warehouseId]);

  //   Load total out of stock
  useEffect(() => {
    const ctrl = new AbortController();
    setLoadingOOS(true);
    setOosErr("");

    getTotalOutOfStock({
      storeId: resolvedStoreId || undefined,
      warehouseId, // optional
      distinct: true, // count unique products; set false to count records
      signal: ctrl.signal,
    })
      .then(({ totalOutOfStock }) => setTotalOOS(totalOutOfStock ?? 0))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setTotalOOS(mockDashboard.totals.totalOutOfStock);
          return;
        }
        setOosErr(e.message || "Failed to load");
      })
      .finally(() => setLoadingOOS(false));

    return () => ctrl.abort();
  }, [resolvedStoreId, warehouseId]);

  //   Load total sale invoices
  useEffect(() => {
    const ctrl = new AbortController();
    setLoadingInv(true);
    // setInvErr("");
    getSalesInvoiceTotals({ signal: ctrl.signal })
      .then(({ totals }) => setInvTotals(totals))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setInvTotals({
            count: mockDashboard.general.orders,
            totalAmount: mockDashboard.totals.totalAmount,
            totalPaid: mockDashboard.totals.totalAmount,
            totalDue: 0,
          });
          return;
        }
        setInvoiceTotalsErr(e.message || "Failed to load");
      })
      .finally(() => setLoadingInv(false));
    return () => ctrl.abort();
  }, []);

  //   Total Supplier
  useEffect(() => {
    const ctrl = new AbortController();
    setLoadingSuppliers(true);
    setSupErr("");

    // Optional filters: { from, to, status: 'active' | 'inactive' | ['active','inactive'], q }
    getTotalSuppliers({ signal: ctrl.signal })
      .then(({ totalSuppliers }) => setSupplierCount(totalSuppliers ?? 0))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setSupplierCount(mockDashboard.general.suppliers);
          return;
        }
        setSupErr(e.message || "Failed to load");
      })
      .finally(() => setLoadingSuppliers(false));

    return () => ctrl.abort();
  }, []);

  //   Total Customer
  useEffect(() => {
    const ctrl = new AbortController();
    setLoadingCustomers(true);
    setCustErr("");

    getTotalCustomers({ signal: ctrl.signal })
      .then(({ totalCustomers }) => setCustomerCount(totalCustomers ?? 0))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setCustomerCount(mockDashboard.general.customers);
          return;
        }
        setCustErr(e.message || "Failed to load");
      })
      .finally(() => setLoadingCustomers(false));

    return () => ctrl.abort();
  }, []);

  //   Total order
  useEffect(() => {
    const ctrl = new AbortController();
    setLoadingOrders(true);
    setOrderErr("");

    // Optional filters: { from, to, status, paymentType, customerId, q }
    getTotalOrders({ signal: ctrl.signal })
      .then(({ totalOrders }) => setOrderCount(totalOrders ?? 0))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setOrderCount(mockDashboard.general.orders);
          return;
        }
        setOrderErr(e.message || "Failed to load");
      })
      .finally(() => setLoadingOrders(false));

    return () => ctrl.abort();
  }, []);

  useEffect(() => {
    const ctrl = new AbortController();
    setLoadingCO(true);
    setCoErr("");
    getCustomersOverview({ period: custPeriod, signal: ctrl.signal })
      .then(({ totals, percentages, series }) => {
        setFirstTime(totals?.firstTime ?? 0);
        setReturning(totals?.returning ?? 0);
        setFirstTimePct(percentages?.firstTimePct ?? 0);
        setReturningPct(percentages?.returningPct ?? 0);
        setSeries(
          Array.isArray(series) ? series : [percentages?.firstTimePct ?? 0]
        );
      })
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setFirstTime(18);
          setReturning(10);
          setFirstTimePct(64);
          setReturningPct(36);
          setSeries([64]);
          return;
        }
        setCoErr(e.message || "Failed to load");
      })
      .finally(() => setLoadingCO(false));
    return () => ctrl.abort();
  }, [custPeriod]);

  //   Top selling products
  function startOfTodayLocal() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  const { from, to } = useMemo(() => {
    const now = new Date();
    let start;
    if (topPeriod === "weekly") {
      start = new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000);
    } else if (topPeriod === "monthly") {
      start = new Date(now.getTime() - 29 * 24 * 60 * 60 * 1000);
    } else {
      start = startOfTodayLocal();
    }
    // format as YYYY-MM-DD
    const fmt = (d) => d.toISOString().slice(0, 10);
    return { from: fmt(start), to: fmt(now) };
  }, [topPeriod]);

  useEffect(() => {
    const ctrl = new AbortController();
    setLoadingTop(true);
    setTopErr("");
    getTopSellingProducts({
      storeId: resolvedStoreId || undefined,
      // warehouseId, // optionally include if you have it
      from,
      to,
      limit: 5,
      sortBy: "quantity", // or "revenue"
      signal: ctrl.signal,
    })
      .then(({ items }) => setTopItems(Array.isArray(items) ? items : []))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setTopItems(mockDashboard.topProducts);
          return;
        }
        setTopErr(e.message || "Failed to load");
      })
      .finally(() => setLoadingTop(false));

    return () => ctrl.abort();
  }, [resolvedStoreId, from, to]);

  //   top low stock product

  const resolvedWarehouseId = useMemo(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("warehouseId") || "";
    }
    return "";
  }, []);

  useEffect(() => {
    const ctrl = new AbortController();
    setLowLoading(true);
    setLowErr("");

    const lang =
      typeof navigator !== "undefined" &&
      navigator.language?.toLowerCase().startsWith("ar")
        ? "ar"
        : "en";

    getLowStock({
      storeId: resolvedStoreId || undefined,
      warehouseId: resolvedWarehouseId || undefined,
      limit: 5,
      sort: "alertGapAsc", // most critical first
      lang,
      signal: ctrl.signal,
    })
      .then(({ items }) => setLowItems(Array.isArray(items) ? items : []))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setLowItems(mockDashboard.lowStock);
          return;
        }
        setLowErr(e.message || "Failed to load");
      })
      .finally(() => setLowLoading(false));

    return () => ctrl.abort();
  }, [resolvedStoreId, resolvedWarehouseId]);

  const periodLabel1 =
    topPeriod === `${window.translate("today")}`
      ? `${window.translate("Today")}`
      : topPeriod === `${window.translate("weekly")}`
      ? `${window.translate("Weekly")}`
      : `${window.translate("Monthly")}`;

  // for a simple % badge, show each item's revenue share of the list (cosmetic only)
  const totalRevenue = useMemo(
    () => topItems.reduce((sum, it) => sum + Number(it.revenue || 0), 0),
    [topItems]
  );

  const customerChart = useMemo(
    () => ({
      chart: { sparkline: { enabled: true } },
      plotOptions: {
        radialBar: {
          hollow: { size: "60%" },
          dataLabels: {
            value: {
              formatter: (val) => `${Math.round(val)}%`,
            },
          },
        },
      },
      labels: [`${window.translate("First Time")}`],
    }),
    []
  );

  const periodLabel =
    custPeriod === "today"
      ? window.translate("Today")
      : custPeriod === "weekly"
      ? window.translate("Weekly")
      : window.translate("Monthly");

  const t = (key) =>
    typeof window !== "undefined" && window?.translate
      ? window.translate(key)
      : key;

  const periodLabelRS =
    rsPeriod === "today"
      ? window.translate("Today")
      : rsPeriod === "monthly"
      ? window.translate("Monthly") 
      : window.translate("Weekly"); 

  const lang =
    typeof navigator !== "undefined" &&
    navigator.language?.toLowerCase().startsWith("ar")
      ? "ar"
      : "en";

  const selectRsPeriod = (p) => {
    if (p !== rsPeriod) {
      setRsLoading(true); // show loader instantly on change
      setRsPeriod(p);
    }
  };

  useEffect(() => {
    const ctrl = new AbortController();
    setRsErr("");
    getRecentSales({
      period: rsPeriod,
      limit: 5,
      source: ["invoice", "online"],
      lang,
      signal: ctrl.signal,
    })
      .then(({ items }) => setRsItems(Array.isArray(items) ? items : []))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setRsItems(mockDashboard.recentSales);
          return;
        }
        setRsErr(e.message || window.translate("Failed to load"));
      })
      .finally(() => setRsLoading(false));
    return () => ctrl.abort();
  }, [rsPeriod, lang]);

  const fallbackImg = "assets/img/products/product-11.jpg";

  // Recent Transaction

  useEffect(() => {
    const ctrl1 = new AbortController();
    const ctrl2 = new AbortController();

    setSaleLoading(true);
    setSaleErr("");
    getRecentTransactions({
      type: "sale",
      period: "weekly",
      limit: 5,
      lang,
      signal: ctrl1.signal,
    })
      .then(({ items }) => setSaleRows(Array.isArray(items) ? items : []))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setSaleRows(mockDashboard.saleRows);
          return;
        }
        setSaleErr(
          e.status === 403
            ? window.translate("No store is linked to this user. Link a store to view recent sales.")
            : e.message || window.translate("Failed to load")
        );
      })
      .finally(() => setSaleLoading(false));

    setInvLoading(true);
    setInvErr("");
    getRecentTransactions({
      type: "invoice",
      period: "weekly",
      limit: 5,
      lang,
      signal: ctrl2.signal,
    })
      .then(({ items }) => setInvRows(Array.isArray(items) ? items : []))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setSaleRows(mockDashboard.saleRows);
          return;
        }
        setSaleErr(
          e.status === 403
            ? "No store is linked to this user. Link a store to view recent sales."
            : e.message || "Failed to load"
        );
      })
      .finally(() => setInvLoading(false));

    return () => {
      ctrl1.abort();
      ctrl2.abort();
    };
  }, [lang]);

  function fmtDate(iso) {
    try {
      const d = new Date(iso);
      return d.toLocaleDateString(undefined, {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return "—";
    }
  }
  function fmtCurrency(n, currency = "KWD", locale = "en-KW") {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(Number(n || 0));
  }
  function saleBadge(status) {
    // Completed | Partial | Draft
    if (status === "Completed")
      return { cls: "badge badge-success badge-xs", text: "Completed" };
    if (status === "Partial")
      return { cls: "badge badge-warning badge-xs", text: "Partial" };
    if (status === "Draft")
      return { cls: "badge badge-pink badge-xs", text: "Draft" };
    return { cls: "badge bg-secondary badge-xs", text: status || "—" };
  }
  function invBadge(status) {
    // Paid | Unpaid | Overdue
    if (status === "Paid")
      return { cls: "badge badge-success badge-xs", text: "Paid" };
    if (status === "Overdue")
      return { cls: "badge badge-warning badge-xs", text: "Overdue" };
    if (status === "Unpaid")
      return { cls: "badge badge-danger badge-xs", text: "Unpaid" };
    return { cls: "badge bg-secondary badge-xs", text: status || "—" };
  }
  const avatarFallback = "assets/img/customer/customer16.jpg";

  function formatWhen(iso) {
    const d = new Date(iso);
    const now = new Date();
    const startToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    return d >= startToday
      ? "Today"
      : d.toLocaleDateString(undefined, {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
  }

  function statusBadge(item) {
    // Normalize to your visual set: Processing (purple), Completed (success), Onhold (cyan), Cancelled (danger)
    if (item.source === "online") {
      if (item.status === "Completed")
        return { cls: "badge badge-success badge-xs", text: "Completed" };
      if (item.paymentStatus === "Overdue")
        return { cls: "badge badge-cyan badge-xs", text: "Onhold" };
      return { cls: "badge bg-purple badge-xs", text: "Processing" }; // Pending/default
    }
    // invoice
    if (item.status === "Paid")
      return { cls: "badge badge-success badge-xs", text: "Completed" };
    if (item.status === "Overdue")
      return { cls: "badge badge-cyan badge-xs", text: "Onhold" };
    if (item.status === "Unpaid")
      return { cls: "badge bg-purple badge-xs", text: "Processing" };
    return { cls: "badge bg-secondary badge-xs", text: item.status || "—" };
  }

  //   Get Top Customers

  const periodLabelTC = useMemo(() => {
    switch (topCustPeriod) {
      case "today":
        return window.translate("Today");
      case "monthly":
        return window.translate("Monthly");
      default:
        return window.translate("Weekly");
    }
  }, [topCustPeriod]);

  const formatMoney = (n) =>
    typeof n === "number"
      ? `$${n.toLocaleString(undefined, { maximumFractionDigits: 2 })}`
      : "—";

  useEffect(() => {
    const ctrl = new AbortController();
    setTcLoading(true);
    setTcErr("");
    getTopCustomers({ period: topCustPeriod, limit: 5, signal: ctrl.signal })
      .then(({ items }) => setTcItems(items || []))
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setTcItems(mockDashboard.topCustomers);
          return;
        }
        setTcErr(e.message || window.translate("Failed to load"));
      })
      .finally(() => setTcLoading(false));
    return () => ctrl.abort();
  }, [topCustPeriod]);

  //   Get top category
  const periodLabelCat = useMemo(() => {
    if (catPeriod === "today") return window.translate("Today");
    if (catPeriod === "monthly") return window.translate("Monthly");
    return window.translate("Weekly");
  }, [catPeriod]);
  useEffect(() => {
    const ctrl = new AbortController();
    setLoadingTopCat(true);
    setTopCatErr("");

    getTopCategories({ period: catPeriod, limit: 3, signal: ctrl.signal })
      .then((data) =>
        setTopCat(
          data || {
            items: [],
            totalCategories: 0,
            totalProducts: 0,
            chart: { labels: [], series: [] },
          }
        )
      )
      .catch((e) => {
        if (e.name === "AbortError") return;
        if (isDemoActive()) {
          setDemo(true);
          setTopCat(mockDashboard.topCategories);
          return;
        }
        setTopCatErr(e.message || "Failed to load");
      })
      .finally(() => setLoadingTopCat(false));

    return () => ctrl.abort();
  }, [catPeriod]);

  //   Get Order statistics

  useEffect(() => {
    const ctrl = new AbortController();
    setLoading(true);
    setErr("");

    getOrderStatistics({
      period,
      metric: "count", // or "amount" for revenue heat
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC",
      signal: ctrl.signal,
    })
      .then(({ series }) => setHeatSeries(series || []))
      .catch((e) => {
        if (e.name === "AbortError" || e.name === "CanceledError") return;
        if (isDemoActive()) {
          setDemo(true);
          setHeatSeries(mockDashboard.heatSeries);
          return;
        }
        setErr(e.message || "Failed to load order statistics");
      })
      .finally(() => setLoading(false));

    return () => ctrl.abort();
  }, [period]);

  const doughnutData = useMemo(() => {
    const labels = topCat?.chart?.labels || [];
    const series = topCat?.chart?.series || [];
    return {
      labels,
      datasets: [
        {
          data: series,
          // simple palette; adjust to your theme if needed
          backgroundColor: [
            "#5e60ce",
            "#ff922b",
            "#22b8cf",
            "#845ef7",
            "#ffa8a8",
            "#51cf66",
          ],
          borderWidth: 0,
        },
      ],
    };
  }, [topCat]);

  const doughnutOptions = useMemo(
    () => ({
      cutout: "60%",
      plugins: {
        legend: { display: false },
        tooltip: { enabled: true },
      },
      maintainAspectRatio: false,
    }),
    []
  );

  //   const data = {
  //     datasets: [
  //       {
  //         label: ["Lifestyles", "Sports", "Electronics"],
  //         data: [16, 24, 50],
  //         backgroundColor: ["#092C4C", "#E04F16", "#FE9F43"],
  //         borderWidth: 5,
  //         borderRadius: 10,
  //         hoverBorderWidth: 0, // Border radius for curved edges
  //         cutout: "50%",
  //       },
  //     ],
  //   };
  //   const option = {
  //     responsive: true,
  //     maintainAspectRatio: false,
  //     layout: {
  //       padding: {
  //         top: -20,
  //         bottom: -20,
  //       },
  //     },
  //     plugins: {
  //       legend: {
  //         display: false, // Hide the legend
  //       },
  //     },
  //   };

  // ----- Base options (now defined!) -----
  const heatOptionsBase = {
    chart: { type: "heatmap", height: 370 },
    plotOptions: {
      heatmap: {
        radius: 4,
        enableShades: false,
        colorScale: {
          ranges: [
            // we'll override below; this is just a fallback
            { from: 0, to: 99, color: "#FFE3CB" },
            { from: 100, to: 200, color: "#FE9F43" },
          ],
        },
      },
    },
    legend: { show: false },
    dataLabels: { enabled: false },
    grid: { padding: { top: -20, bottom: 0, left: 0, right: 0 } },
    yaxis: { labels: { offsetX: -15 } },
  };

  // ----- Highlight "1" value via colorScale first-match rule -----
  const heatOptions = useMemo(
    () => ({
      ...heatOptionsBase,
      plotOptions: {
        heatmap: {
          ...heatOptionsBase.plotOptions.heatmap,
          colorScale: {
            ranges: [
              { from: 1, to: 1, color: "#6B7280" }, // highlight exactly 1
              { from: 0, to: 0, color: "#FFF4E8" }, // optional: very pale zero
              { from: 2, to: 99, color: "#FFE3CB" },
              { from: 100, to: 200, color: "#FE9F43" },
            ],
          },
        },
      },
    }),
    []
  );

  const highlightedSeries = useMemo(
    () =>
      (heatSeries || []).map((row) => ({
        name: row.name,
        data: (row.data || []).map((pt) =>
          pt && typeof pt.y === "number" && pt.y === 1
            ? { ...pt, fillColor: "#6B7280" } // force the highlight color
            : pt
        ),
      })),
    [heatSeries]
  );

  const chartOptions = useMemo(
    () => ({
      chart: { type: "bar", toolbar: { show: false } },
      xaxis: { categories: stats.categories || [] },
      dataLabels: { enabled: false },
      plotOptions: {
        bar: { columnWidth: "45%", borderRadius: 6 },
      },
      yaxis: {
        labels: {
          formatter: (v) => (v >= 1000 ? `${(v / 1000).toFixed(1)}k` : `${v}`),
        },
      },
      tooltip: {
        y: { formatter: (val) => formatCurrency(val) },
      },
    }),
    [stats.categories]
  );

  const chartSeries = useMemo(
    () => [{ name: "Revenue", data: stats.series?.revenue || [] }],
    [stats.series]
  );

  const revenueYoY = stats.yoy?.revenuePct ?? 0;
  const revBadgeUp = revenueYoY >= 0;

  // Return for Demo
  function DemoBanner({ reason }) {
    return (
      <div className="rounded-3 border border-dashed p-3 mb-3 bg-warning-subtle text-body">
        <div className="fw-semibold">{window.translate("Demo Mode")}</div>
        <div className="small opacity-75">
          {window.translate(
            "No store is linked to this user. Showing sample data only."
          )}
          {reason ? <span className="ms-1">({reason})</span> : null}
        </div>
        {/* <button
          className="btn btn-sm btn-outline-dark mt-2"
          onClick={() => (window.location.href = "/settings/store-link")}
        >
          Link a Store
        </button> */}
      </div>
    );
  }

  DemoBanner.propTypes = {
    reason: PropTypes.string,
  };

  DemoBanner.defaultProps = {
    reason: "",
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {demo && <DemoBanner reason={getDemoReason()} />}
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-2">
          <div className="mb-3">
            <h1 className="mb-1">{window.translate("Welcome Admin")}</h1>
          </div>
          <div className="input-icon-start position-relative mb-3">
            <span className="input-icon-addon fs-16 text-gray-9">
              <i className="ti ti-calendar" />
            </span>
            <PredefinedDateRanges />
          </div>
        </div>
        <div className="row">
          {/* Get Total Products */}
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card bg-primary sale-widget flex-fill">
              <div className="card-body d-flex align-items-center">
                <span className="sale-icon bg-white text-primary">
                  <i className="ti ti-file-text fs-24" />
                </span>
                <div className="ms-2">
                  {/* If you must keep the original key, change to "Total Sales" */}
                  <p className="text-white mb-1 fs-2">{t("TotalProducts")}</p>
                  <div className="d-inline-flex align-items-center flex-wrap gap-2">
                    <h4 className="text-white">
                      {loadingProducts
                        ? "—"
                        : Number(totalProducts).toLocaleString(undefined, {
                            maximumFractionDigits: 0,
                          })}
                    </h4>

                    {/* Keep the badge only if you compute growth; otherwise hide/comment out */}
                    {/* <span className="badge badge-soft-primary">
                  <i className="ti ti-arrow-up me-1" />+22%
                </span> */}
                  </div>
                  {prodErr ? (
                    <div className="text-white-50 small mt-1">{prodErr}</div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          {/* Total Stock card (wired to API) */}
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card bg-secondary sale-widget flex-fill">
              <div className="card-body d-flex align-items-center">
                <span className="sale-icon bg-white text-secondary">
                  <i className="ti ti-repeat fs-24" />
                </span>
                <div className="ms-2">
                  {/* If you really mean 'Sales Return', change this label back */}
                  <p className="text-white mb-1 fs-2">{t("Total Stock")}</p>
                  <div className="d-inline-flex align-items-center flex-wrap gap-2">
                    <h4 className="text-white">
                      {loadingStock
                        ? "—"
                        : Number(totalStock).toLocaleString(undefined, {
                            maximumFractionDigits: 0,
                          })}
                    </h4>
                    {/* Remove or compute trend if you have it */}
                    {/* <span className="badge badge-soft-danger">
                  <i className="ti ti-arrow-down me-1" />-22%
                </span> */}
                  </div>
                  {stockErr ? (
                    <div className="text-white-50 small mt-1">{stockErr}</div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          {/* Total Out of Stock card (wired to API) */}
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card bg-teal sale-widget flex-fill">
              <div className="card-body d-flex align-items-center">
                <span className="sale-icon bg-white text-teal">
                  <i className="ti ti-gift fs-24" />
                </span>
                <div className="ms-2">
                  {/* Change the label to match the metric */}
                  <p className="text-white mb-1 fs-2">
                    {t("Total Out of Stock")}
                  </p>
                  <div className="d-inline-flex align-items-center flex-wrap gap-2">
                    <h4 className="text-white">
                      {loadingOOS
                        ? "—"
                        : Number(totalOOS).toLocaleString(undefined, {
                            maximumFractionDigits: 0,
                          })}
                    </h4>
                    {/* Remove or compute this badge if you add trends */}
                    {/* <span className="badge badge-soft-success">
            <i className="ti ti-arrow-up me-1" />+22%
          </span> */}
                  </div>
                  {oosErr ? (
                    <div className="text-white-50 small mt-1">{oosErr}</div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card bg-info sale-widget flex-fill">
              <div className="card-body d-flex align-items-center">
                <span className="sale-icon bg-white text-info">
                  <i className="ti ti-brand-pocket fs-24" />
                </span>
                <div className="ms-2">
                  <p className="text-white mb-1 fs-2">
                    {t("Total sales invoce")}
                  </p>
                  <div className="d-inline-flex align-items-center flex-wrap gap-2">
                    <h4 className="text-white">
                      {loadingInv
                        ? "—"
                        : `KWD ${Number(
                            invTotals?.totalAmount || 0
                          ).toLocaleString(undefined, {
                            maximumFractionDigits: 0,
                          })}`}
                    </h4>
                    {/* Keep/remove if you later compute trends */}
                    {/* <span className="badge badge-soft-success">
            <i className="ti ti-arrow-up me-1" />+22%
          </span> */}
                  </div>
                  {invoiceTotalsErr ? (
                    <div className="text-white-50 small mt-1">
                      {invoiceTotalsErr}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {/* Profit */}
          {/* <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card revenue-widget flex-fill">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom">
                  <div>
                    <h4 className="mb-1">0 KWD</h4>
                    <p>{t("Profit")}</p>
                  </div>
                  <span className="revenue-icon bg-cyan-transparent text-cyan">
                    <i className="fa-solid fa-layer-group fs-16" />
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-0">
                    <span className="fs-13 fw-bold text-success">+35%</span>{" "}
                    {t("vs")}
                    {t("Last Month")}
                  </p>
                  <Link
                    to="profit-and-loss.html"
                    className="text-decoration-underline fs-13 fw-medium"
                  >
                    {t("View All")}
                  </Link>
                </div>
              </div>
            </div>
          </div> */}
          {/* /Profit */}
          {/* Invoice */}
          {/* <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card revenue-widget flex-fill">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom">
                  <div>
                    <h4 className="mb-1">0 KWD</h4>
                    <p>{t("Invoice Due")}</p>
                  </div>
                  <span className="revenue-icon bg-teal-transparent text-teal">
                    <i className="ti ti-chart-pie fs-16" />
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-0">
                    <span className="fs-13 fw-bold text-success">+35%</span>{" "}
                    {t("vs")}
                    {t("lastMonth")}
                  </p>
                  <Link
                    to={route.invoicereport}
                    className="text-decoration-underline fs-13 fw-medium"
                  >
                    {t("View All")}
                  </Link>
                </div>
              </div>
            </div>
          </div> */}
          {/* /Invoice */}
          {/* Expenses */}
          {/* <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card revenue-widget flex-fill">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom">
                  <div>
                    <h4 className="mb-1">0 KWD</h4>
                    <p>{t("Total Expenses")}</p>
                  </div>
                  <span className="revenue-icon bg-orange-transparent text-orange">
                    <i className="ti ti-lifebuoy fs-16" />
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-0">
                    <span className="fs-13 fw-bold text-success">+41%</span>{" "}
                    {t("vs")}
                    {t("lastMonth")}
                  </p>
                  <Link
                    to={route.expenselist}
                    className="text-decoration-underline fs-13 fw-medium"
                  >
                    {t("View All")}
                  </Link>
                </div>
              </div>
            </div>
          </div> */}
          {/* /Expenses */}
          {/* Returns */}
          {/* <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card revenue-widget flex-fill">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom">
                  <div>
                    <h4 className="mb-1">0 KWD</h4>
                    <p>{t("Total Payment Returns")}</p>
                  </div>
                  <span className="revenue-icon bg-indigo-transparent text-indigo">
                    <i className="ti ti-hash fs-16" />
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-0">
                    <span className="fs-13 fw-bold text-danger">-20%</span>{" "}
                    {t("vs")}
                    {t("lastMonth")}
                  </p>
                  <Link
                    to={route.salesreport}
                    className="text-decoration-underline fs-13 fw-medium"
                  >
                    {t("View All")}
                  </Link>
                </div>
              </div>
            </div>
          </div> */}
          {/* /Returns */}
        </div>
        <div className="row">
          <>
            {/* Sales & Purchase */}
            {/* <div className="col-xxl-8 col-xl-7 col-sm-12 col-12 d-flex">
              <div className="card flex-fill">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <div className="d-inline-flex align-items-center">
                    <span className="title-icon bg-soft-primary fs-16 me-2">
                      <i className="ti ti-shopping-cart" />
                    </span>
                    <h5 className="card-title mb-0">Sales &amp; Purchase</h5>
                  </div>
                  <ul className="nav btn-group custom-btn-group">
                    <Link className="btn btn-outline-light" to="#">
                      1D
                    </Link>
                    <Link className="btn btn-outline-light" to="#">
                      1W
                    </Link>
                    <Link className="btn btn-outline-light" to="#">
                      1M
                    </Link>
                    <Link className="btn btn-outline-light" to="#">
                      3M
                    </Link>
                    <Link className="btn btn-outline-light" to="#">
                      6M
                    </Link>
                    <Link className="btn btn-outline-light active" to="#">
                      1Y
                    </Link>
                  </ul>
                </div>
                <div className="card-body pb-0">
                  <div>
                    <div className="d-flex align-items-center gap-2">
                      <div className="border p-2 br-8">
                        <p className="d-inline-flex align-items-center mb-1">
                          <i className="ti ti-circle-filled fs-8 text-primary-300 me-1" />
                          Total Purchase
                        </p>
                        <h4>3K</h4>
                      </div>
                      <div className="border p-2 br-8">
                        <p className="d-inline-flex align-items-center mb-1">
                          <i className="ti ti-circle-filled fs-8 text-primary me-1" />
                          Total Sales
                        </p>
                        <h4>1K</h4>
                      </div>
                    </div>
                    <div id="sales-daychart">
                      <Chart
                        options={salesDayChart}
                        series={salesDayChart.series}
                        type="bar"
                        height={245}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* /Sales & Purchase */}
          </>

          {/* Top Selling Products */}
          <div className="col-12 d-flex">
            <div className="card flex-fill w-100">
              <div className="card-header">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-info fs-16 me-2">
                    <i className="ti ti-info-circle" />
                  </span>
                  <h5 className="card-title mb-0">
                    {t("Overall Information")}
                  </h5>
                </div>
              </div>

              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <div className="info-item border bg-light p-3 text-center">
                      <div className="mb-3 text-info fs-24">
                        <i className="ti ti-user-check" />
                      </div>
                      <p className="mb-1">{t("Suppliers")}</p>
                      <h5>
                        {loadingSuppliers
                          ? "—"
                          : Number(supplierCount).toLocaleString(undefined, {
                              maximumFractionDigits: 0,
                            })}
                      </h5>
                      {supErr ? (
                        <div className="text-danger small mt-1">{supErr}</div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="info-item border bg-light p-3 text-center">
                      <div className="mb-3 text-orange fs-24">
                        <i className="ti ti-users" />
                      </div>
                      <p className="mb-1" style={{ fontSize: "11px" }}>
                        {t("Customers")}
                      </p>
                      <h5>
                        {loadingCustomers
                          ? "—"
                          : Number(customerCount).toLocaleString(undefined, {
                              maximumFractionDigits: 0,
                            })}
                      </h5>
                      {custErr ? (
                        <div className="text-danger small mt-1">{custErr}</div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="info-item border bg-light p-3 text-center">
                      <div className="mb-3 text-teal fs-24">
                        <i className="ti ti-shopping-cart" />
                      </div>
                      <p className="mb-1">{t("Orders")}</p>
                      <h5>
                        {loadingOrders
                          ? "—"
                          : Number(orderCount).toLocaleString(undefined, {
                              maximumFractionDigits: 0,
                            })}
                      </h5>
                      {orderErr ? (
                        <div className="text-danger small mt-1">{orderErr}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-footer pb-sm-0">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                  <h6>{t("Customers Overview")}</h6>
                  <div className="dropdown dropdown-wraper">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-sm"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="ti ti-calendar me-1" />
                      {periodLabel}
                    </Link>
                    <ul className="dropdown-menu p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => setCustPeriod("today")}
                        >
                          {window.translate("Today")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => setCustPeriod("weekly")}
                        >
                          {window.translate("Weekly")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => setCustPeriod("monthly")}
                        >
                          {window.translate("Monthly")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* stack on xs, 2 cols from md+ */}
                <div className="row gy-4 justify-content-center align-items-center customer-overview">
                  {/* Chart */}
                  <div className="col-12 col-sm-8 col-md-5 col-lg-4 d-flex justify-content-center">
                    <div className="chart-wrap mx-auto">
                      <Chart
                        options={customerChart}
                        series={series}
                        type="radialBar"
                        height={180}
                      />
                    </div>
                  </div>

                  {/* Stats */}
                  <div className="col-12 col-sm-10 col-md-6 col-lg-5 d-flex justify-content-center">
                    <div className="w-100" style={{ maxWidth: 420 }}>
                      <div className="row g-3 justify-content-center">
                        <div className="col-6">
                          <div
                            className="text-center text-md-start border-0 border-md-end pe-0 pe-md-3"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <h2 className="mb-1">
                              {loadingCO
                                ? "—"
                                : Number(firstTime).toLocaleString()}
                            </h2>
                            <p className="text-orange mb-2">
                              {t("First Time")}
                            </p>
                            <span className="badge badge-success badge-xs d-inline-flex align-items-center">
                              <i className="ti ti-arrow-up-left me-1" />
                              {loadingCO ? "—" : `${firstTimePct}%`}
                            </span>
                          </div>
                        </div>

                        <div className="col-6">
                          <div
                            className="text-center text-md-start"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <h2 className="mb-1">
                              {loadingCO
                                ? "—"
                                : Number(returning).toLocaleString()}
                            </h2>
                            <p className="text-teal mb-2">{t("Return")}</p>
                            <span className="badge badge-success badge-xs d-inline-flex align-items-center">
                              <i className="ti ti-arrow-up-left me-1" />
                              {loadingCO ? "—" : `${returningPct}%`}
                            </span>
                          </div>
                        </div>
                      </div>

                      {coErr ? (
                        <div className="text-danger small mt-2">{coErr}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {/* Top Selling Products */}
          <div className="col-xxl-4 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-pink fs-16 me-2">
                    <i className="ti ti-box" />
                  </span>
                  <h5 className="card-title mb-0">
                    {t("Top Selling Products")}
                  </h5>
                </div>

                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="ti ti-calendar me-1" />
                    {periodLabel1}
                    {loadingTop && (
                      <span
                        className="spinner-border spinner-border-sm ms-2"
                        role="status"
                        aria-hidden="true"
                        style={{ width: "1rem", height: "1rem" }}
                      />
                    )}
                  </Link>

                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={(e) => {
                          e.preventDefault();
                          selectTopPeriod("today");
                        }}
                      >
                        {t("Today")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={(e) => {
                          e.preventDefault();
                          selectTopPeriod("weekly");
                        }}
                      >
                        {t("Weekly")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={(e) => {
                          e.preventDefault();
                          selectTopPeriod("monthly");
                        }}
                      >
                        {t("Monthly")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="card-body sell-product">
                {topErr ? (
                  <div className="text-danger small mb-2">{topErr}</div>
                ) : null}

                {loadingTop ? (
                  <>
                    {/* simple loading placeholders */}
                    <div className="d-flex align-items-center justify-content-between border-bottom py-2 opacity-50">
                      <div className="d-flex align-items-center">
                        <span
                          className="avatar avatar-lg bg-light rounded-circle"
                          style={{ width: 48, height: 48 }}
                        />
                        <div className="ms-2">
                          <div className="placeholder-glow">
                            <span className="placeholder col-8" />
                          </div>
                          <div className="placeholder-glow">
                            <span className="placeholder col-6" />
                          </div>
                        </div>
                      </div>
                      <span className="badge bg-outline-secondary badge-xs">
                        —
                      </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between border-bottom py-2 opacity-50">
                      <div className="d-flex align-items-center">
                        <span
                          className="avatar avatar-lg bg-light rounded-circle"
                          style={{ width: 48, height: 48 }}
                        />
                        <div className="ms-2">
                          <div className="placeholder-glow">
                            <span className="placeholder col-8" />
                          </div>
                          <div className="placeholder-glow">
                            <span className="placeholder col-6" />
                          </div>
                        </div>
                      </div>
                      <span className="badge bg-outline-secondary badge-xs">
                        —
                      </span>
                    </div>
                  </>
                ) : topItems.length === 0 ? (
                  <div className="text-muted py-3">
                    {t("No sales in this period")}
                  </div>
                ) : (
                  topItems.map((it, idx) => {
                    const name =
                      (it.productName &&
                        (it.productName.en || it.productName.ar)) ||
                      it.sku ||
                      "Unnamed Product";
                    const img = resolveImageUrl(it.image, "assets/img/products/product-01.jpg");
                    const qty = Number(it.quantitySold || 0);
                    const revenue = Number(it.revenue || 0);
                    const share =
                      totalRevenue > 0
                        ? Math.round((revenue / totalRevenue) * 100)
                        : 0;

                    const rowClass =
                      idx < topItems.length - 1 ? "border-bottom" : "";
                    return (
                      <div
                        className={`d-flex align-items-center justify-content-between ${rowClass}`}
                        key={String(it.productId || idx)}
                      >
                        <div className="d-flex align-items-center">
                          <Link to="#" className="avatar avatar-lg">
                            <img src={img} alt="img" />
                          </Link>
                          <div className="ms-2">
                            <h6 className="fw-bold mb-1">
                              <Link to="#">{name}</Link>
                            </h6>
                            <div className="d-flex align-items-center item-list">
                              <p className="me-3 mb-0">
                                {formatCurrency(revenue)}
                              </p>
                              <p className="mb-0">
                                {qty.toLocaleString()} {window.translate("Sales")}
                              </p>
                            </div>
                          </div>
                        </div>
                        {/* Cosmetic share badge (relative to current list) */}
                        <span
                          className={`badge ${
                            share >= 25
                              ? "bg-outline-success"
                              : "bg-outline-secondary"
                          } badge-xs d-inline-flex align-items-center`}
                        >
                          <i
                            className={`ti ${
                              share >= 25 ? "ti-arrow-up-left" : "ti-minus"
                            } me-1`}
                          />
                          {share}%
                        </span>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
          {/* /Top Selling Products */}
          {/* Low Stock Products */}

          <div className="col-xxl-4 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-danger fs-16 me-2">
                    <i className="ti ti-alert-triangle" />
                  </span>
                  <h5 className="card-title mb-0">{t("Low Stock Products")}</h5>
                </div>
                <Link
                  to={route.lowstock}
                  className="fs-13 fw-bold text-decoration-underline"
                >
                  {t("View All")}
                </Link>
              </div>

              <div className="card-body" aria-busy={lowLoading}>
                {lowErr ? (
                  <div className="text-danger small mb-2">{lowErr}</div>
                ) : null}

                {lowLoading ? (
                  <>
                    {/* skeleton rows */}
                    {[...Array(3)].map((_, i) => (
                      <div
                        key={i}
                        className="d-flex align-items-center justify-content-between mb-4 opacity-50"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <span
                            className="avatar avatar-lg bg-light rounded-circle"
                            style={{ width: 48, height: 48 }}
                          />
                          <div className="ms-2">
                            <div className="placeholder-glow">
                              <span className="placeholder col-8" />
                            </div>
                            <div className="placeholder-glow">
                              <span className="placeholder col-6" />
                            </div>
                          </div>
                        </div>
                        <div className="text-end">
                          <div className="placeholder-glow">
                            <span className="placeholder col-4" />
                          </div>
                          <div className="placeholder-glow">
                            <span className="placeholder col-3" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : lowItems.length === 0 ? (
                  <div className="text-muted py-3">
                    {t("No low stock items")}
                  </div>
                ) : (
                  lowItems.map((it, idx) => {
                    const name =
                      typeof it.productName === "string"
                        ? it.productName
                        : it.productName?.en || it.productName?.ar || "Unnamed";
                    const img = resolveImageUrl(it.image, "assets/img/products/product-01.jpg");
                    const sku =
                      it.sku && it.sku !== "N/A"
                        ? it.sku
                        : String(it.productId).slice(-6);
                    const inStock = Number(it.quantity ?? 0);

                    const rowClass =
                      idx < lowItems.length - 1 ? "mb-4" : "mb-0";
                    return (
                      <div
                        key={String(it.id || it.productId || idx)}
                        className={`d-flex align-items-center justify-content-between ${rowClass}`}
                      >
                        <div className="d-flex align-items-center">
                          <Link to="#" className="avatar avatar-lg">
                            <img src={img} alt="product" />
                          </Link>
                          <div className="ms-2">
                            <h6 className="fw-bold mb-1">
                              <Link to="#">{name}</Link>
                            </h6>
                            <p className="fs-13 mb-0">{window.translate("SKU")} : #{sku}</p>
                          </div>
                        </div>
                        <div className="text-end">
                          <p className="fs-13 mb-1">{t("Instock")}</p>
                          <h6 className="text-orange fw-bold">
                            {inStock.toLocaleString(undefined, {
                              maximumFractionDigits: 0,
                            })}
                          </h6>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>

          {/* /Low Stock Products */}
          {/* Recent Sales */}
          <div className="col-xxl-4 col-md-12 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-pink fs-16 me-2">
                    <i className="ti ti-box" />
                  </span>
                  <h5 className="card-title mb-0">{t("Recent Sales")}</h5>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="ti ti-calendar me-1" />
                    {periodLabelRS}
                    {rsLoading && (
                      <span
                        className="spinner-border spinner-border-sm ms-2"
                        role="status"
                        aria-hidden="true"
                        style={{ width: "1rem", height: "1rem" }}
                      />
                    )}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={(e) => {
                          e.preventDefault();
                          selectRsPeriod("today");
                        }}
                      >
                        {window.translate("Today")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={(e) => {
                          e.preventDefault();
                          selectRsPeriod("weekly");
                        }}
                      >
                        {window.translate("Weekly")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={(e) => {
                          e.preventDefault();
                          selectRsPeriod("monthly");
                        }}
                      >
                        {window.translate("Monthly")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="card-body" aria-busy={rsLoading}>
                {rsErr ? (
                  <div className="text-danger small mb-3">{rsErr}</div>
                ) : null}

                {rsLoading ? (
                  <>
                    {/* skeleton rows */}
                    {[...Array(3)].map((_, i) => (
                      <div
                        key={i}
                        className="d-flex align-items-center justify-content-between mb-4 opacity-50"
                      >
                        <div className="d-flex align-items-center">
                          <span
                            className="avatar avatar-lg bg-light rounded-circle"
                            style={{ width: 48, height: 48 }}
                          />
                          <div className="ms-2">
                            <div className="placeholder-glow">
                              <span className="placeholder col-8" />
                            </div>
                            <div className="placeholder-glow">
                              <span className="placeholder col-6" />
                            </div>
                          </div>
                        </div>
                        <div className="text-end">
                          <div className="placeholder-glow">
                            <span className="placeholder col-4" />
                          </div>
                          <div className="placeholder-glow mt-1">
                            <span className="placeholder col-5" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : rsItems.length === 0 ? (
                  <div className="text-muted">{t("No recent sales")}</div>
                ) : (
                  rsItems.map((it, idx) => {
                    const { cls, text } = statusBadge(it);
                    const img = resolveImageUrl(it.image, "assets/img/products/product-01.jpg") || fallbackImg;
                    const title =
                      it.title || (it.reference ? `#${it.reference}` : "—");
                    const cat =
                      it.category ||
                      (it.source === "invoice" ? "Invoice" : "—");
                    const amt = formatCurrency(it.amount);
                    const when = formatWhen(it.date);

                    const rowClass = idx < rsItems.length - 1 ? "mb-4" : "mb-0";
                    return (
                      <div
                        key={it.id}
                        className={`d-flex align-items-center justify-content-between ${rowClass}`}
                      >
                        <div className="d-flex align-items-center">
                          <Link to="#" className="avatar avatar-lg">
                            <img src={img} alt="img" />
                          </Link>
                          <div className="ms-2">
                            <h6 className="fw-bold mb-1">
                              <Link to="#">{title}</Link>
                            </h6>
                            <div className="d-flex align-items-center item-list">
                              <p className="mb-0 me-3">{cat}</p>
                              <p className="text-gray-9 mb-0">{amt}</p>
                            </div>
                          </div>
                        </div>
                        <div className="text-end">
                          <p className="fs-13 mb-1">{when}</p>
                          <span
                            className={`${cls} d-inline-flex align-items-center`}
                          >
                            <i className="ti ti-circle-filled fs-5 me-1" />
                            {text}
                          </span>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
          {/* /Recent Sales */}
        </div>
        <div className="row">
          {/* Sales Statics */}
          <div className="col-xl-6 col-sm-12 col-12 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-danger fs-16 me-2">
                    <i className="ti ti-alert-triangle" />
                  </span>
                  <h5 className="card-title mb-0">{t("Sales Statics")}</h5>
                </div>

                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="ti ti-calendar me-1" />
                    {selYear}
                    {loadingStats && (
                      <span
                        className="spinner-border spinner-border-sm ms-2"
                        role="status"
                        aria-hidden="true"
                        style={{ width: "1rem", height: "1rem" }}
                      />
                    )}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    {yearsList.map((y) => (
                      <li key={y}>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={(e) => {
                            e.preventDefault();
                            setSelYear(y);
                          }}
                        >
                          {y}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="card-body pb-0" aria-busy={loadingStats}>
                {statsErr ? (
                  <div className="text-danger small mb-2">{statsErr}</div>
                ) : null}

                <div className="d-flex align-items-center flex-wrap gap-2">
                  <div className="border p-2 br-8">
                    <h5 className="d-inline-flex align-items-center text-teal gap-1">
                      {loadingStats
                        ? "—"
                        : formatCurrency(stats.totals?.revenue || 0)}
                      <span
                        className={`badge ${
                          revBadgeUp ? "badge-success" : "badge-danger"
                        } badge-xs d-inline-flex align-items-center ms-2`}
                      >
                        <i
                          className={`ti ${
                            revBadgeUp
                              ? "ti-arrow-up-left"
                              : "ti-arrow-down-right"
                          } me-1`}
                        />
                        {loadingStats ? "—" : `${Math.abs(revenueYoY)}%`}
                      </span>
                    </h5>
                    <p>{t("Revenue")}</p>
                  </div>

                  <div className="border p-2 br-8">
                    <h5 className="d-inline-flex align-items-center text-orange gap-1">
                      {/* No expense model provided; show 0 or hide */}
                      {loadingStats
                        ? "—"
                        : stats.totals?.expense == null
                        ? formatCurrency(0)
                        : formatCurrency(stats.totals.expense)}
                      {/* Optional: remove the badge for Expense or compute if you add expenses */}
                      <span
                        className="badge badge-danger badge-xs d-inline-flex align-items-center ms-2"
                        style={{ display: "none" }}
                      >
                        <i className="ti ti-arrow-down-right me-1" /> 0%
                      </span>
                    </h5>
                    <p>{t("Expense")}</p>
                  </div>
                </div>

                <div id="sales-statistics" className="mt-2">
                  {loadingStats ? (
                    <div className="placeholder-glow" style={{ height: 290 }}>
                      <span
                        className="placeholder col-12"
                        style={{ height: 290, display: "block" }}
                      />
                    </div>
                  ) : (
                    <ReactApexChart
                      options={chartOptions}
                      series={chartSeries}
                      type="bar"
                      height={290}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* /Sales Statics */}

          {/* Recent Transactions */}
          <div className="col-xl-6 col-sm-12 col-12 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-orange fs-16 me-2">
                    <i className="ti ti-flag" />
                  </span>
                  <h5 className="card-title mb-0">
                    {t("Recent Transactions")}
                  </h5>
                </div>
                <Link
                  to={route.onlineorder}
                  className="fs-13 fw-medium text-decoration-underline"
                >
                  {t("View All")}
                </Link>
              </div>

              <div className="card-body p-0">
                <ul className="nav nav-tabs nav-justified transaction-tab">
                  <li className="nav-item">
                    <Link
                      className="nav-link active"
                      to="#sale"
                      data-bs-toggle="tab"
                    >
                      {t("Sale")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="#purchase-transaction"
                      data-bs-toggle="tab"
                    >
                      {t("Purchase")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="#quotation"
                      data-bs-toggle="tab"
                    >
                      {t("Quotation")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="#expenses"
                      data-bs-toggle="tab"
                    >
                      {t("Expenses")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="#invoices"
                      data-bs-toggle="tab"
                    >
                      {t("Invoices")}
                    </Link>
                  </li>
                </ul>

                <div className="tab-content">
                  {/* SALE TAB */}
                  <div className="tab-pane show active" id="sale">
                    <div className="table-responsive">
                      <table className="table table-borderless custom-table">
                        <thead className="thead-light">
                          <tr>
                            <th>{t("Date")}</th>
                            <th>{t("Customer")}</th>
                            <th>{t("Status")}</th>
                            <th>{t("Total")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {saleErr ? (
                            <tr>
                              <td colSpan={4} className="text-danger">
                                {saleErr}
                              </td>
                            </tr>
                          ) : saleLoading ? (
                            [...Array(3)].map((_, i) => (
                              <tr key={i} className="opacity-50">
                                <td>
                                  <span className="placeholder col-6" />
                                </td>
                                <td>
                                  <div className="d-flex align-items-center file-name-icon">
                                    <span className="avatar avatar-md bg-light" />
                                    <div className="ms-2">
                                      <h6 className="fw-medium mb-1">
                                        <span className="placeholder col-8" />
                                      </h6>
                                      <span className="placeholder col-5" />
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <span className="placeholder col-6" />
                                </td>
                                <td className="fs-16 fw-bold text-gray-9">
                                  <span className="placeholder col-6" />
                                </td>
                              </tr>
                            ))
                          ) : saleRows.length === 0 ? (
                            <tr>
                              <td colSpan={4} className="text-muted">
                                {t("No recent sales")}
                              </td>
                            </tr>
                          ) : (
                            saleRows.map((r) => {
                              const { cls, text } = saleBadge(r.status);
                              const name =
                                r.customer?.name || r.customer?.id || "—";
                              return (
                                <tr key={r.id}>
                                  <td>{fmtDate(r.date)}</td>
                                  <td>
                                    <div className="d-flex align-items-center file-name-icon">
                                      <span className="avatar avatar-md">
                                        <img
                                          src={avatarFallback}
                                          className="img-fluid"
                                          alt="customer"
                                        />
                                      </span>
                                      <div className="ms-2">
                                        <h6 className="fw-medium mb-0">
                                          <Link to="#">{name}</Link>
                                        </h6>
                                        <span className="fs-13 text-orange">
                                          #{r.orderId}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <span className={cls}>
                                      <i className="ti ti-circle-filled fs-5 me-1" />
                                      {text}
                                    </span>
                                  </td>
                                  <td className="fs-16 fw-bold text-gray-9">
                                    {fmtCurrency(r.total)}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* PURCHASE TAB (still static until you add a model) */}
                  <div className="tab-pane fade" id="purchase-transaction">
                    {/* keep your existing static table here */}
                    {/* ... */}
                  </div>

                  {/* QUOTATION TAB (static placeholder) */}
                  <div className="tab-pane" id="quotation">
                    {/* keep your existing static table here */}
                    {/* ... */}
                  </div>

                  {/* EXPENSES TAB (static placeholder) */}
                  <div className="tab-pane fade" id="expenses">
                    {/* keep your existing static table here */}
                    {/* ... */}
                  </div>

                  {/* INVOICES TAB */}
                  <div className="tab-pane" id="invoices">
                    <div className="table-responsive">
                      <table className="table table-borderless custom-table">
                        <thead className="thead-light">
                          <tr>
                            <th> {window.translate("Customer")}</th>
                            <th> {window.translate("Due Date")}</th>
                            <th> {window.translate("status")}</th>
                            <th> {window.translate("Amount")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invErr ? (
                            <tr>
                              <td colSpan={4} className="text-danger">
                                {invErr}
                              </td>
                            </tr>
                          ) : invLoading ? (
                            [...Array(3)].map((_, i) => (
                              <tr key={i} className="opacity-50">
                                <td>
                                  <div className="d-flex align-items-center file-name-icon">
                                    <span className="avatar avatar-md bg-light" />
                                    <div className="ms-2">
                                      <h6 className="fw-medium mb-1">
                                        <span className="placeholder col-8" />
                                      </h6>
                                      <span className="placeholder col-4" />
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <span className="placeholder col-6" />
                                </td>
                                <td>
                                  <span className="placeholder col-5" />
                                </td>
                                <td className="text-gray-9">
                                  <span className="placeholder col-6" />
                                </td>
                              </tr>
                            ))
                          ) : invRows.length === 0 ? (
                            <tr>
                              <td colSpan={4} className="text-muted">
                                {window.translate("No invoices.")}
                              </td>
                            </tr>
                          ) : (
                            invRows.map((r) => {
                              const { cls, text } = invBadge(r.status);
                              const name = r.customer?.name || "—";
                              return (
                                <tr key={r.id}>
                                  <td>
                                    <div className="d-flex align-items-center file-name-icon">
                                      <span className="avatar avatar-md">
                                        <img
                                          src={avatarFallback}
                                          className="img-fluid"
                                          alt="customer"
                                        />
                                      </span>
                                      <div className="ms-2">
                                        <h6 className="fw-medium mb-0">
                                          <Link to="#">{name}</Link>
                                        </h6>
                                        <span className="fs-13 text-orange">
                                          #{r.reference}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    {r.dueDate ? fmtDate(r.dueDate) : "—"}
                                  </td>
                                  <td>
                                    <span className={cls}>
                                      <i className="ti ti-circle-filled fs-5 me-1" />
                                      {text}
                                    </span>
                                  </td>
                                  <td className="text-gray-9">
                                    {fmtCurrency(r.amount)}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Recent Transactions */}
        </div>
        <div className="row">
          {/* Top Customers */}
          <div className="col-xxl-4 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-orange fs-16 me-2">
                    <i className="ti ti-users" />
                  </span>
                  <h5 className="card-title mb-0">{t("Top Customers")}</h5>
                </div>

                {/* Period dropdown */}
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="ti ti-calendar me-1" />
                    {periodLabelTC}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={() => setTopCustPeriod("today")}
                      >
                        {window.translate("Today")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={() => setTopCustPeriod("weekly")}
                      >
                         {window.translate("Weekly")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={() => setTopCustPeriod("monthly")}
                      >
                         {window.translate("Monthly")}
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* <Link
                  to={route.customer}
                  className="fs-13 fw-medium text-decoration-underline ms-auto"
                >
                  {t("View All")}
                </Link> */}
              </div>

              <div className="card-body">
                {tcErr ? (
                  <div className="text-danger small mb-2">{tcErr}</div>
                ) : null}

                {/* Loading skeletons */}
                {tcLoading ? (
                  <>
                    {[...Array(3)].map((_, i) => (
                      <div
                        key={i}
                        className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-3 flex-wrap gap-2 opacity-50"
                      >
                        <div className="d-flex align-items-center">
                          <span
                            className="avatar avatar-lg bg-light rounded-circle flex-shrink-0"
                            style={{ width: 56, height: 56 }}
                          />
                          <div className="ms-2">
                            <div className="placeholder-glow mb-1">
                              <span className="placeholder col-8" />
                            </div>
                            <div className="placeholder-glow">
                              <span className="placeholder col-6" />
                            </div>
                          </div>
                        </div>
                        <div className="text-end">
                          <div className="placeholder-glow">
                            <span className="placeholder col-4" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : tcItems.length === 0 ? (
                  <div className="text-muted">
                    {t("No customers in this period")}
                  </div>
                ) : (
                  tcItems.map((c, idx) => {
                    const rowClass =
                      idx < tcItems.length - 1 ? "border-bottom mb-3 pb-3" : "";
                    const avatar = resolveImageUrl(c.image, "assets/img/customer/customer11.jpg");
                    const country = c.country || t("Unknown");
                    const orders = Number(c.orders || 0);
                    const spent = formatMoney(c.totalSpent);

                    return (
                      <div
                        key={String(c.id || idx)}
                        className={`d-flex align-items-center justify-content-between ${rowClass} flex-wrap gap-2`}
                      >
                        <div className="d-flex align-items-center">
                          <Link
                            to="#"
                            className="avatar avatar-lg flex-shrink-0"
                          >
                            <img src={avatar} alt="img" />
                          </Link>
                          <div className="ms-2">
                            <h6 className="fs-14 fw-bold mb-1">
                              <Link to="#">{c.name || "—"}</Link>
                            </h6>
                            <div className="d-flex align-items-center item-list">
                              <p className="d-inline-flex align-items-center mb-0 me-3">
                                <i className="ti ti-map-pin me-1" />
                                {country}
                              </p>
                              <p className="mb-0">
                                {orders.toLocaleString()} {t("Orders")}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="text-end">
                          <h5 className="mb-0">{spent}</h5>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
          {/* /Top Customers */}

          {/* Top Categories */}
          <div className="col-xxl-4 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-orange fs-16 me-2">
                    <i className="ti ti-users" />
                  </span>
                  <h5 className="card-title mb-0">{t("Top Categories")}</h5>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-flex align-items-center"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="ti ti-calendar me-1" />
                    {periodLabelCat}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={() => setCatPeriod("today")}
                      >
                        {window.translate("Today")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={() => setCatPeriod("weekly")}
                      >
                        {window.translate("Weekly")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={() => setCatPeriod("monthly")}
                      >
                        {window.translate("Monthly")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="card-body">
                {topCatErr ? (
                  <div className="text-danger small mb-2">{topCatErr}</div>
                ) : null}

                <div className="d-flex align-items-center justify-content-between flex-wrap gap-4 mb-4">
                  <div style={{ height: 230, width: 200 }}>
                    {loadingTopCat ? (
                      <div className="d-flex align-items-center justify-content-center w-100 h-100 opacity-50">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">{window.translate("Loading…")}</span>
                        </div>
                      </div>
                    ) : (
                      <Doughnut data={doughnutData} options={doughnutOptions} />
                    )}
                  </div>

                  <div>
                    {loadingTopCat ? (
                      <>
                        <div className="mb-3">
                          <div className="placeholder-glow">
                            <span className="placeholder col-7" />
                          </div>
                          <div className="placeholder-glow">
                            <span className="placeholder col-5" />
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="placeholder-glow">
                            <span className="placeholder col-6" />
                          </div>
                          <div className="placeholder-glow">
                            <span className="placeholder col-4" />
                          </div>
                        </div>
                        <div className="mb-0">
                          <div className="placeholder-glow">
                            <span className="placeholder col-6" />
                          </div>
                          <div className="placeholder-glow">
                            <span className="placeholder col-4" />
                          </div>
                        </div>
                      </>
                    ) : (
                      (topCat.items || []).slice(0, 3).map((c, i) => {
                        const name = c?.name?.en || c?.name?.ar || "—";
                        const sales = Number(c?.sales ?? 0).toLocaleString();
                        const className =
                          i === 0
                            ? "category-item category-primary"
                            : i === 1
                            ? "category-item category-orange"
                            : "category-item category-secondary";
                        return (
                          <div
                            className={className}
                            key={String(c.categoryId || i)}
                          >
                            <p className="fs-13 mb-1">{name}</p>
                            <h2 className="d-flex align-items-center">
                              {sales}
                              <span className="fs-13 fw-normal text-default ms-1">
                                {window.translate("Sales")}
                              </span>
                            </h2>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>

                <h6 className="mb-2">{t("Category Statistics")}</h6>
                <div className="border br-8">
                  <div className="d-flex align-items-center justify-content-between border-bottom p-2">
                    <p className="d-inline-flex align-items-center mb-0">
                      <i className="ti ti-square-rounded-filled text-indigo fs-8 me-2" />
                      {t("Total Number Of Categories")}
                    </p>
                    <h5>
                      {loadingTopCat
                        ? "—"
                        : Number(topCat?.totalCategories || 0).toLocaleString()}
                    </h5>
                  </div>
                  <div className="d-flex align-items-center justify-content-between p-2">
                    <p className="d-inline-flex align-items-center mb-0">
                      <i className="ti ti-square-rounded-filled text-orange fs-8 me-2" />
                      {t("Total Number Of Products")}
                    </p>
                    <h5>
                      {loadingTopCat
                        ? "—"
                        : Number(topCat?.totalProducts || 0).toLocaleString()}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Top Categories */}

          {/* Order Statistics */}
          <div className="col-xxl-4 col-md-12 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-indigo fs-16 me-2">
                    <i className="ti ti-package" />
                  </span>
                  <h5 className="card-title mb-0">{t("Order Statistics")}</h5>
                </div>

                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="ti ti-calendar me-1" />
                    {label}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={() => setPeriod("today")}
                      >
                        {window.translate("Today")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={() => setPeriod("weekly")}
                      >
                        {window.translate("Weekly")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={() => setPeriod("monthly")}
                      >
                        {window.translate("Monthly")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="card-body pb-0">
                {err ? (
                  <div className="text-danger small mb-2">{err}</div>
                ) : null}

                <div id="heat_chart" style={{ minHeight: 370 }}>
                  {loading ? (
                    // simple loader; replace with your skeleton/spinner if you have one
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: 370 }}
                    >
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      />
                      {window.translate("Loading…")}
                    </div>
                  ) : (
                    <ApexCharts
                      options={heatOptions}
                      series={highlightedSeries}
                      type="heatmap"
                      height={370}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* /Order Statistics */}
        </div>
      </div>
      <div className="copyright-footer d-flex align-items-center justify-content-between border-top bg-white gap-3 flex-wrap">
        <p className="fs-13 text-gray-9 mb-0">
          {t("2024-2025 © Hamilton POS. All Right Reserved")}
        </p>
        <p>
          {window.translate(`Designed & Developed By`)}{" "}
          <Link to="#" className="link-primary">
            {window.translate(`Hamilton`)}
          </Link>
        </p>
      </div>
    </div>
  );
};

NewDashboard.propTypes = {
  storeId: PropTypes.string, // optional; falls back to localStorage if absent
  warehouseId: PropTypes.string, // optional filter
};

NewDashboard.defaultProps = {
  storeId: undefined,
  warehouseId: undefined,
};

export default NewDashboard;
